import { render, staticRenderFns } from "./ModalHistoricoBoleto.vue?vue&type=template&id=b3a591b2&scoped=true"
import script from "./ModalHistoricoBoleto.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoBoleto.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoricoBoleto.vue?vue&type=style&index=0&id=b3a591b2&prod&scoped=true&lang=css"
import style1 from "./ModalHistoricoBoleto.vue?vue&type=style&index=1&id=b3a591b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a591b2",
  null
  
)

export default component.exports